var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.5C9.2475 10.5 5.25 11.4975 5.25 13.5V15H17.25V13.5C17.25 11.4975 13.2525 10.5 11.25 10.5ZM4.5 7.5V5.25H3V7.5H0.75V9H3V11.25H4.5V9H6.75V7.5M11.25 9C12.0456 9 12.8087 8.68393 13.3713 8.12132C13.9339 7.55871 14.25 6.79565 14.25 6C14.25 5.20435 13.9339 4.44129 13.3713 3.87868C12.8087 3.31607 12.0456 3 11.25 3C10.4544 3 9.69129 3.31607 9.12868 3.87868C8.56607 4.44129 8.25 5.20435 8.25 6C8.25 6.79565 8.56607 7.55871 9.12868 8.12132C9.69129 8.68393 10.4544 9 11.25 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.573d899fb9db2b298315bdf8fa3f7893.svg";
export { ForwardRef as ReactComponent };